import { Meta, StoryObj } from "@storybook/nextjs-vite";
import { DownloadCard } from "./DownloadCard";

const meta: Meta<typeof DownloadCard> = {
  title: "Download card",
  component: DownloadCard,
  args: {
    type: "Download",
    title: "Title",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
    media: {
      type: "image",
      image:
        "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png?disable=upscale&width=1024",
    },
    link: {
      title: "Download Free Trial",
      url: "#",
      dld: "dld",
      dlt: "dlt",
      underTitle: "Fully functional for 30 days",
    },
    secondLink: {
      title: "Quick View",
      dld: "dld",
      dlt: "dlt",
    },
    modal: (
      <div className="flex flex-col border p-4">
        <div className="flex min-h-10 items-center gap-8 pb-8">
          <span className="text-headline text-subhead-s font-bold">
            Modal Title
          </span>
          <div id="close-btn-box" className="ml-auto size-6" />
        </div>
        <p className="text-body-s text-body-primary">
          Placeholder modal content
        </p>
      </div>
    ),
  },
  decorators: [
    (Story) => (
      <div className="mx-auto max-w-lg">
        <Story />
      </div>
    ),
  ],
};

export default meta;

export const White: StoryObj<typeof DownloadCard> = {
  globals: {
    backgrounds: {
      value: "white",
    },
  },
  render: (args) => (
    <section data-theme="white">
      <DownloadCard {...args} />
    </section>
  ),
};

export const Gray: StoryObj<typeof DownloadCard> = {
  globals: {
    backgrounds: {
      value: "gray",
    },
  },
  render: (args) => (
    <section data-theme="gray">
      <DownloadCard {...args} />
    </section>
  ),
};

export const Black: StoryObj<typeof DownloadCard> = {
  globals: {
    backgrounds: {
      value: "black",
    },
  },
  render: (args) => (
    <section data-theme="black">
      <DownloadCard {...args} />
    </section>
  ),
};

export const WithLearnMoreButton: StoryObj<typeof DownloadCard> = {
  args: {
    type: "Download",
    title: "Title",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
    link: {
      title: "Download Free Trial",
      url: "#",
      dld: "dld",
      dlt: "dlt",
      underTitle: "Fully functional for 30 days",
    },
    secondLink: undefined,
    thirdLink: {
      title: "Learn More",
      url: "#",
      dld: "dld",
      dlt: "dlt",
    },
  },
};

export const WithoutImage: StoryObj<typeof DownloadCard> = {
  args: {
    type: "Download",
    title: "Title",
    media: undefined,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
    link: {
      title: "Download Free Trial",
      url: "#",
      dld: "dld",
      dlt: "dlt",
    },
  },
};
